<script setup>
import IconSearch from '@/components/icons/IconSearch.vue'

const { type } = defineProps({
  type: {
    type: String,
    default: 'text'
  },
  label: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: 'Suche'
  }
})
const text = defineModel()
const emit = defineEmits(['change', 'input'])

function change(event) {
  emit('change', event)
}

function input(event) {
  emit('input', event)
}
</script>

<template>
  <div class="search__container">
    <IconSearch class="search__icon" />
    <label class="input" :class="{ 'input--disabled': disabled }">
      <input
        :type="type"
        class="input__field"
        :disabled="disabled"
        v-model="text"
        :placeholder="placeholder"
        @change="change"
        @input="input"
      />
    </label>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/sass_variables.scss' as *;

.search__container {
  display: flex;
  align-items: center;
  padding: 7px 8px;
  width: 100%;

  height: 36px;
  border-radius: 10px;

  background: #fff; /* rgba(255, 255, 255, 0.12); */
  border: 1px solid #666;
  color: #242635; /* rgba(255, 255, 255, 0.3); */

  &:focus-within {
    outline: 2x solid var(--clr-blue-700);
  }

  .search__icon {
    width: 16px;
    height: 16px;
  }

  @media screen and (min-width: $breakpoint-medium) {
    .search__icon {
      width: 24px;
      height: 24px;
    }

    height: 48px;
    border-radius: 22px;
    padding: 7px 16px;
  }

  &__icon {
    margin-right: 12px;
    color: rgba(255, 255, 255, 0.12);
    width: 16px;
  }

  .input {
    display: block;
    position: relative;
    flex: 1;

    &__label {
      position: absolute;
      top: 21px;
      left: 16px;
      background: transparent;
      transition-property: font-size, font-weight, top;
      transition-duration: 0.3s;
      line-height: 1;
      font-size: 18px;
    }

    &__field {
      display: block;
      padding: 12px;
      width: 100%;
      height: 100%;
      background: transparent;
      outline: none;
      caret-color: var(--clr-red-500);
      line-height: 1.5;
      appearance: none;
      font-size: 16px;
      color: #242635; /* rgba(255, 255, 255, 0.3); */


      &::placeholder {
        color: #242635; /* rgba(255, 255, 255, 0.3); */
      }

      @media screen and (min-width: $breakpoint-medium) {
        font-size: 20px;
        padding: 12px 16px 12px;
      }
    }
  }
}

// .input {
//   display: block;
//   position: relative;

//   &__label {
//     background: transparent;

//     padding-left: 24px;
//     position: absolute;
//     top: 18px;
//     left: 16px;
//     color: rgba(255, 255, 255, 0.30);
//     pointer-events: none;

//     font-feature-settings: 'case' on;
//     font-family: "Open Sans";
//     font-size: 16px;
//     font-style: normal;
//     font-weight: 400;

//     line-height: 1; /* 137.5% */
//     letter-spacing: -0.408px;

//     transition-property: font-size, font-weight, top;
//     transition-duration: 0.3s;

//     &--small {
//       @extend %label-small;
//     }
//   }

//   &__field {
//     display: block;
//     padding: 20px 16px 12px;
//     width: 100%;
//     height: 100%;
//     outline: none;
//     caret-color: var(--clr-red-500);
//     line-height: 1.5;
//     appearance: none;
//     color: black;

//     font-feature-settings: 'case' on;
//     font-family: "Open Sans";
//     font-size: 16px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 22px; /* 137.5% */
//     letter-spacing: -0.408px;

//     &[type="date"] {
//       line-height: 1.23;
//     }
//   }

//   &:focus-within &__label {
//     @extend %label-small;
//   }

//   &:focus-within {
//     border: 1px solid var(--clr-blue-700);
//     outline: 1px solid var(--clr-blue-700);
//   }

//   &--disabled {
//     background: var(--clr-gray-50);
//   }

//   &--disabled &__label {
//     color: var(--clr-gray-300);
//   }
// }

// %label-small {
//   font-size: 0.625rem;
//   font-weight: 400;
//   top: 10px;
// }
</style>
